import { render, staticRenderFns } from "./seeadoctor.vue?vue&type=template&id=406dcc2f&scoped=true&"
import script from "./seeadoctor.vue?vue&type=script&lang=js&"
export * from "./seeadoctor.vue?vue&type=script&lang=js&"
import style0 from "./seeadoctor.vue?vue&type=style&index=0&id=406dcc2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406dcc2f",
  null
  
)

export default component.exports